import ChipLevel from './ChipLevel.vue';

// @ts-ignore
ChipLevel.install = (Vue) => {
  Vue.component((ChipLevel as any).options.name, ChipLevel);
};

export default ChipLevel;
